import "./verifyCompanyAccount.scss";
const VerifyCompanyAccount = () => {
  return <div>verify</div>;
};
export default VerifyCompanyAccount;